var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowRoundedDown7X5 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.3,0.3c0.4-0.4,1-0.4,1.3,0l1.9,2l1.9-2c0.4-0.4,1-0.4,1.3,0c0.4,0.4,0.4,0.9,0,1.3L3.5,5L0.3,1.6 C-0.1,1.2-0.1,0.6,0.3,0.3z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowRoundedDown7X5, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-rounded-down-7x5.f2eb00bc.svg";
export { ForwardRef as ReactComponent };